module.exports = __webpack_public_path__ + "static/img/oprCt_bg_white_03.1b70fd88.svg";